import { useTranslation } from '../../i18n'
import zoomLogo from '../../assets/zoom.svg'
import googleMeetLogo from '../../assets/google-meet.svg'
import teamsLogo from '../../assets/microsoft-teams.svg'
import hackerrankLogo from '../../assets/hackerrank.svg'
import './Platforms.css'

// Brand colors from each platform's guidelines
const platforms = [
  {
    name: 'Zoom',
    logo: zoomLogo,
  },
  {
    name: 'Google Meet',
    logo: googleMeetLogo,
  },
  {
    name: 'Microsoft Teams',
    logo: teamsLogo,
  },
  {
    name: 'HackerRank',
    logo: hackerrankLogo,
  },
  {
    name: 'LeetCode',
    logo: 'https://cdn.simpleicons.org/leetcode/FFA116',
  },
  {
    name: 'CodeSignal',
    logo: 'https://cdn.simpleicons.org/codesignal/1062FE',
  },
]

function Platforms() {
  const { t } = useTranslation()

  return (
    <section className="platforms-section" aria-label="Supported platforms">
      <div className="container">
        <p className="platforms-title">{t('platformsTitle')}</p>
        <div className="platforms-bar">
          {platforms.map((platform) => (
            <div key={platform.name} className="platform-item">
              <img
                className="platform-logo"
                src={platform.logo}
                alt={platform.name}
                width="24"
                height="24"
                loading="lazy"
              />
              <span className="platform-name">{platform.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Platforms
